import { redirect } from "@tanstack/react-router"
import { toast } from "react-toastify"
import { can } from "./can"
import { MTTEntities, MTTPermissions } from "toptaal-shared"

export const checkPermissions = (
  action: MTTPermissions,
  entity: MTTEntities,
) => {
  if (!can(action, entity)) {
    toast.error(
      "Je hebt geen toegang tot deze pagina. Neem contact op met de beheerder.",
    )

    throw redirect({ to: "/beheer" })
  }
}
